import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { qrCodesActions } from '../actions/qr-codes.actions';
import { selectCache, selectLoading } from '../selectors/qr-codes.selector';

@Service()
export class QrCodesFacade {
    private readonly store = inject(Store);

    readonly cache = this.store.selectSignal(selectCache);
    readonly loading = this.store.selectSignal(selectLoading);

    loadQrCode(url: string): void {
        this.store.dispatch(qrCodesActions.loadQrCode({ url }));
    }

    cancelLoading(): void {
        this.store.dispatch(qrCodesActions.cancelLoading());
    }
}
